// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2aLXE","requiredAsterisk":"Info_requiredAsterisk__1qw--"};